import { z } from 'zod';

export const ApplicationRequestInformationSchema = z.object({
    id: z.string().optional(),
    name: z.string().optional(),
    legalBasis: z.string().optional(),
    requestSubject: z.string().optional(),
    // LEGACY-BYPASS: LB-20260914-06 — requestId relaxed to optional for legacy rows
    requestId: z.string().optional(), // Relaxed for compatibility
    details: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateApplicationRequestInformationSchema = ApplicationRequestInformationSchema.omit({ id: true });
export const UpdateApplicationRequestInformationSchema = ApplicationRequestInformationSchema;